export const debounce = (
  func: Function,
  timeout = 300
) => {
  let timer: NodeJS.Timeout;  //  Closure
  return (...args: any) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}